export default __webpack_public_path__ + "static/PathingGraphic-401baa1effdab1e4ca3b7b858ad5506c.png";